module.exports = __webpack_public_path__ + "static/media/about_person.12ca439e.jpg";